import React, { useState, useEffect } from "react";
import { useTheme } from "../context/ThemeContext.js"; // Import the custom hook for theme context
import { HexColorPicker } from "react-colorful"; // Import HexColorPicker from react-colorful
import { TextField, InputAdornment, Box, Button } from "@mui/material";
import subscriptionStatus from "../components/SubscriptionStatus.js";
import { useNavigate } from "react-router-dom";
const CustomizeTheme = () => {
  const { theme, updateTheme } = useTheme(); // Get the current theme and the function to update it
  const [activeTab, setActiveTab] = useState("theme"); // State to manage which tab is active
  const isSubscribed = subscriptionStatus();
  const navigate = useNavigate();
  // Function to handle color change
  const handleColorChange = (colorType) => (color) => {
    updateTheme((prevTheme) => {
      const newTheme = { ...prevTheme, [colorType]: color };

      // Save updated theme to localStorage
      localStorage.setItem("theme", JSON.stringify(newTheme));

      return newTheme;
    });
  };

  // Effect to load theme from localStorage when the page is loaded or reloaded
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      const parsedTheme = JSON.parse(savedTheme);
      updateTheme(parsedTheme); // Apply saved theme to the state
    }
  }, [updateTheme]);

  return (
    <div style={{ padding: "20px" }}>
      {/* Tab navigation */}

      <div style={{ display: "flex", marginBottom: "20px" }}>
        {isSubscribed && (
          <button
            onClick={() => setActiveTab("theme")}
            style={{
              padding: "12px 20px",
              fontSize: "16px",
              fontWeight: "600",
              cursor: "pointer",
              border: "none",
              backgroundColor: "transparent",
              color: activeTab === "theme" ? "#E5D8CF" : "#2C3E50", // Active tab gets color
              borderBottom:
                activeTab === "theme" ? "2px solid #E5D8CF" : "none", // Green underline when active
              transition: "all 0.3s ease", // Smooth transition for color and underline
              textTransform: "uppercase",
              marginRight: "20px",
            }}
            onMouseEnter={(e) => (e.target.style.color = "#E5D8CF")} // Hover effect
            onMouseLeave={(e) =>
              (e.target.style.color =
                activeTab === "theme" ? "#E5D8CF" : "#2C3E50")
            }
          >
            Customize Your Theme
          </button>
        )}
      </div>
      {isSubscribed &&
        // Tab Content
        activeTab === "theme" && (
          <div>
            <h3 style={{ color: theme.text }}>Customize Your Theme</h3>

            {/* Use flexbox to display the pickers horizontally with a gap between them */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between", // To ensure equal space between the pickers
                marginBottom: "20px",
              }}
            >
              {/* Background Color Picker */}
              <div style={{ textAlign: "center", padding: "20px" }}>
                <h4 style={{ color: theme.text }}>Background</h4>
                <HexColorPicker
                  color={theme.background} // Set the initial color
                  onChange={handleColorChange("background")} // Update the background color on change
                />
              </div>

              {/* Text Color Picker */}
              <div style={{ textAlign: "center", padding: "20px" }}>
                <h4 style={{ color: theme.text }}>Text</h4>
                <HexColorPicker
                  color={theme.text} // Set the initial color
                  onChange={handleColorChange("text")} // Update the text color on change
                />
              </div>

              {/* Button Color Picker */}
              <div style={{ textAlign: "center", padding: "20px" }}>
                <h4 style={{ color: theme.text }}>Button</h4>
                <HexColorPicker
                  color={theme.button} // Set the initial color
                  onChange={handleColorChange("button")} // Update the button color on change
                />
              </div>

              {/* Table Color Picker */}
              <div style={{ textAlign: "center", padding: "20px" }}>
                <h4 style={{ color: theme.text }}>Table</h4>
                <HexColorPicker
                  color={theme.table} // Set the initial color
                  onChange={handleColorChange("table")} // Update the table color on change
                />
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

export default CustomizeTheme;
